/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
/* tslint:disable: no-duplicate-imports */
import * as MsDyn365 from '@msdyn365-commerce/core';
import classnames from 'classnames';
import * as React from 'react';
import isTargetingCriteriaMatched from '../../Utilities/is-targeting-criteria-match';
import { IMfrmTargettedFooterDisclaimerProps, ITargetingData } from './mfrm-targetted-footer-disclaimer.props.autogenerated';

export interface ITextBlockViewProps extends IMfrmTargettedFooterDisclaimerProps<{}> {
    paragraph?: React.ReactNode;
    className?: string;
}

/**
 *
 * TextBlock component
 */
class TextBlock extends React.PureComponent<IMfrmTargettedFooterDisclaimerProps<{}>> {
    public render(): JSX.Element | null {
        const { className } = this.props.config;

        const textBlockViewProps = {
            ...this.props,
            paragraph: this.getParagraph(),
            className: classnames('ms-text-block', className)
        };
        return this.props.renderView(textBlockViewProps) as React.ReactElement;
    }

    public handleTextChange = (paragraph: MsDyn365.RichText | undefined) => (event: MsDyn365.ContentEditableEvent) =>
        (paragraph = event.target.value);

    private getParagraph = () => {
        const { paragraphs } = this.props.config;
        const value: { paragraph: JSX.Element; isMatched: Boolean }[] = [];
        const { geoLocation, query } = this.props.context.request;
        /* VSI-Customization -- START pushing each 'text-block' with individual targeting criteria inside array */
        paragraphs &&
            paragraphs.forEach(para => {
                const targetingGeoLocation: ITargetingData | undefined = para.targeting;
                const criteriaMatched = isTargetingCriteriaMatched(geoLocation, query, targetingGeoLocation);
                if (criteriaMatched) {
                    value.push({
                        paragraph: (
                            <MsDyn365.RichTextComponent
                                text={para?.paragraph}
                                editProps={{ onEdit: this.handleTextChange(para?.paragraph), requestContext: this.props.context.request }}
                            />
                        ),
                        isMatched: criteriaMatched
                    });
                }
            });
        /* VSI-Customization -- END  */
        let flag = false;
        let paragraph;
        for (const para of value) {
            if (para.isMatched) {
                flag = true;
                paragraph = para.paragraph;
                break;
            }
        }
        return flag ? paragraph : value[0]?.paragraph;
    };
}
export default TextBlock;
